export default "__VITE_ASSET__BMy0buNC__"